export default {
  CITIZENSHIP_HEADER: "Are you a U.S. citizen?",
  RADIO_ITEMS: [
    {
      label: "Yes",
      value: true,
    },
    {
      label: "No",
      value: false,
    },
  ],
  CITIZENSHIP_BUTTON_HEADING: "Continue",
  SUBMIT_ERROR: "Enter a Valid Amount",
};
